import { AppThunk, AppDispatch } from '@app/store/store'
import catchErrorHandler from '@app/store/utils/catchErrorHandler'
import { apiSdk } from '@app/api/endpoints'
import { runtimeConfig } from '@app/common/config'
import { Scalars } from '@app/graphql/service/schema'
import { PROVIDERS } from '@app/constants'

import { actions } from './slice'

export const initSession = (): AppThunk => async (dispatch: AppDispatch) => {
  const CHANNEL_ID = runtimeConfig.joinSproutTherapyConfig?.CHANNEL_ID
  const SERVICE_ID = runtimeConfig.joinSproutTherapyConfig?.SERVICE_ID
  dispatch(actions.requestFetchInitSession())
  try {
    const response = await apiSdk.initSession({
      channelId: CHANNEL_ID,
      serviceId: SERVICE_ID,
      providers: PROVIDERS
    })
    if (!response.channel?.session?.init?.id) {
      throw new Error('Can not init session')
    }
    dispatch(actions.successFetchInitSession(response.channel.session.init.id))
    return response.channel.session.init.id
  } catch (error) {
    catchErrorHandler(error, dispatch, actions.errorFetchInitSession)
  }
}

export const setSessionId = (sessionId: Scalars['UUID']) => async (dispatch: AppDispatch) => {
  try {
    dispatch(actions.setSessionId(sessionId))
  } catch (error) {
    console.error(error.message)
  }
}
